// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import { useTranslation } from "react-i18next";

// const References = ({ isOpen, onClose, references, dir, documentInfo }) => {

//   const navigate = useNavigate();
//   const [isSending, setIsSending] = useState(false);
//   const [imageUrls, setImageUrls] = useState({});
//   const [modalImageUrl, setModalImageUrl] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [zoom, setZoom] = useState(1);
//   const [transformOrigin, setTransformOrigin] = useState("center center");
//   const [sectionStatus, setSectionStatus] = useState({});
//   const { t } = useTranslation();

//   const user = useMemo(() => {
//     return JSON.parse(localStorage.getItem("profileData")) || JSON.parse(sessionStorage.getItem("profileData") || "{}");
//   }, []);

//   const token = useMemo(() => {
//     return localStorage.getItem("token") || sessionStorage.getItem("token");
//   }, []);

//   // Process references into structured form
//   const processReferences = (references) => {
//     if (!references) return { structuredReferences: [], detailsPart: "" };
//     const [tablePart, detailsPart] = references.split("\n\n**Details:**\n\n");
//     const rows = tablePart.split("\n").slice(2);
//     const structuredReferences = rows.map((row) => {
//       const columns = row
//         .split("|")
//         .map((col) => col.trim())
//         .filter(Boolean);
//       console.log(columns);

//       return {
//         documentName: columns[0],
//         sectionName: columns[1],
//         sectionNumber: columns[2],
//       };
//     });
//     return { structuredReferences, detailsPart };
//   };

//   const { structuredReferences, detailsPart } = useMemo(() => processReferences(references), [references]);

//   const checkSections = useCallback(async () => {
//     const statusMap = {};

//     for (const ref of structuredReferences) {
//       const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;

//       try {
//         const params = new URLSearchParams();
//         params.append("document_name", ref.documentName);
//         params.append("section_name", ref.sectionName);
//         params.append("section_number", ref.sectionNumber);
//         params.append("tenantId", user?.tenantId || "");
//         params.append("groupId", user?.groups?.[0]?.id || "");

//         const response = await fetch(
//           `${process.env.REACT_APP_BASEURL}/get-section-image`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/x-www-form-urlencoded",
//               Authorization: `Bearer ${token}`,
//             },
//             body: params.toString(),
//           }
//         );

//         statusMap[key] = response.ok ? "ok" : "error";
//       } catch {
//         statusMap[key] = "error";
//       }
//     }

//     setSectionStatus(statusMap);
//   }, [structuredReferences, user?.tenantId, user?.groups, token]);

//   useEffect(() => {
//     if (structuredReferences.length > 0) {
//       checkSections();
//     }
//   }, [structuredReferences, checkSections]);

//   // Handle clicking a section to fetch or show cached image
//   const handleSectionClick = async (ref) => {
//     const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;

//     if (imageUrls[key]) {
//       setModalImageUrl(imageUrls[key]);
//       setZoom(1);
//       setTransformOrigin("center center");
//       setIsModalOpen(true);
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token") || sessionStorage.getItem("token");
//       const params = new URLSearchParams();
//       params.append("document_name", ref.documentName);
//       params.append("section_name", ref.sectionName);
//       params.append("section_number", ref.sectionNumber);
//       params.append("tenantId", user?.tenantId || null);
//       params.append("groupId", user?.groups[0]?.id || null);

//       const response = await fetch(
//         `${process.env.REACT_APP_BASEURL}/get-section-image`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//             Authorization: `Bearer ${token}`,
//           },
//           body: params.toString(),
//         }
//       );

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(
//           `Failed to fetch image: ${response.status} - ${errorText}`
//         );
//       }

//       const blob = await response.blob();
//       const imageObjectUrl = URL.createObjectURL(blob);

//       setImageUrls((prev) => ({ ...prev, [key]: imageObjectUrl }));
//       setModalImageUrl(imageObjectUrl);
//       setZoom(1);
//       setTransformOrigin("center center");
//       setIsModalOpen(true);
//     } catch (error) {
//       console.error("Error fetching section image:", error);
//       alert("Error fetching section image.");
//     }
//   };

//   // Zoom handling
//   const handleImageClick = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
//     const yPercent = ((e.clientY - rect.top) / rect.height) * 100;

//     if (zoom === 1) {
//       setTransformOrigin(`${xPercent}% ${yPercent}%`);
//       setZoom(2.5);
//     } else {
//       setZoom(1);
//       setTransformOrigin("center center");
//     }
//   };

//   // Email references
//   const handleEmailClick = async () => {
//     if (isSending) return;
//     setIsSending(true);

//     try {
//       const token = localStorage.getItem("token") || sessionStorage.getItem("token");
//       const email = localStorage.getItem("user");
//       if (!email) {
//         alert("User email not found in local storage!");
//         setIsSending(false);
//         return;
//       }

//       const emailContent = `<html><body><h2>Your References</h2><table><thead><tr><th>Document Name</th><th>Section Name</th><th>Section Number</th></tr></thead><tbody>${structuredReferences
//         .map(
//           (ref) =>
//             `<tr><td>${ref.documentName}</td><td>${ref.sectionName}</td><td>${ref.sectionNumber}</td></tr>`
//         )
//         .join("")}</tbody></table><br/><p><strong>Details:</strong><br/>${detailsPart?.replace(
//           /\n/g,
//           "<br/>"
//         )}</p></body></html>`;

//       const response = await axios.post(
//         `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/client/sendRefrenceEmail`,
//         { email, content: emailContent },
//         { headers: { token, "Content-Type": "application/json" } }
//       );

//       if (response.status === 200 || response.status === 201) {
//         navigate("/references-email");
//       } else {
//         console.error("Failed to send email:", response.statusText);
//         setIsSending(false);
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       setIsSending(false);
//     }
//   };

//   // Determine document clickability
//   // const isViewableGroup = user?.groups?.some((g) => g.isViewable === true);
//   // const isDocumentClickable = (isViewableGroup === true || user?.isDocViewable === true) || (isViewableGroup === true && user?.isDocViewable === true);
//   // const isDocumentClickable = (isViewableGroup === true || user?.isDocViewable === true) || (isViewableGroup === true && user?.isDocViewable === true);
//   const mapData = structuredReferences?.map((reference) => {
//     const matchDoc = documentInfo?.find((doc) => reference.documentName.replace(/\.pdf$/i, '') === doc.documentName.replace(/\.pdf$/i, ''))
//     console.log({ matchDoc, documentInfo, reference });
//     return {
//       ...reference,
//       data: matchDoc?.data?.data
//     }
//   })

//   return (
//     <div className="flex justify-center items-center">
//       <div className="w-full max-w-5xl px-6 pb-6 rounded-lg">
//         <h1 className="text-xl font-bold mb-8 text-center">{t("references")}</h1>
//         {structuredReferences.length > 0 ? (
//           <div className="overflow-y-auto max-h-[60vh]">
//             <table className="table-auto w-full border-collapse border border-gray-300">
//               <thead>
//                 <tr className={`bg-gray-200 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>
//                   <th className="border border-gray-300 px-4 py-2 ">
//                     {t("document_name")}
//                   </th>
//                   <th className="border border-gray-300 px-4 py-2 ">
//                     {t("section_name")}
//                   </th>
//                   <th className="border border-gray-300 px-4 py-2 ">
//                     {t("section_number")}
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {mapData?.map((ref, index) => {
//                   const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;
//                   // Extract the complex viewability logic to a function
//                   const isViewable = () => {
//                     const hasNoGroup = ref.data?.group === null;
//                     const isConfidential = ref.data?.group?.type === "CONFIDENTIAL";
//                     const isGroupViewable = user?.groups[0]?.isViewable === true;
//                     const isDocViewable = user?.isDocViewable;
//                     // Case 1: No group, doc is viewable
//                     if (hasNoGroup && isDocViewable === true) return true;
//                     // Case 2: No group, group not viewable, but doc is viewable
//                     if (hasNoGroup && user?.groups[0]?.isViewable === false && isDocViewable === true) return true;
//                     // Case 3: Confidential group or no group, group is viewable, doc not viewable
//                     if ((isConfidential || hasNoGroup) && isGroupViewable && isDocViewable === false) return true;
//                     // Case 4: Confidential group or no group, both group and doc are viewable
//                     if ((isConfidential || hasNoGroup) && isGroupViewable && isDocViewable === true) return true;
//                     return false;
//                   };
//                   return (
//                     <tr key={index} className="hover:bg-gray-100">
//                       <td className="border border-gray-300 px-4 py-2">
//                         {isViewable() ? (
//                           <span
//                             onClick={() =>
//                               window.open(
//                                 `https://nb-client1.s3.ap-southeast-1.amazonaws.com/${ref.documentName}`,
//                                 "_blank"
//                               )
//                             }
//                             className="text-blue-500 cursor-pointer"
//                           >
//                             {ref.documentName}
//                           </span>
//                         ) : (
//                           ref.documentName
//                         )}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {ref.sectionName}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {sectionStatus[key] === "ok" && ref.sectionNumber !== "N/A" ? (
//                           <span
//                             className="text-blue-600 cursor-pointer underline"
//                             onClick={() => handleSectionClick(ref)}
//                           >
//                             {ref.sectionNumber}
//                           </span>
//                         ) : (
//                           <span className="text-gray-500">{ref.sectionNumber}</span>
//                         )}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>

//             {detailsPart && (
//               <div className="mt-4">
//                 <p className="font-bold">{t("details")}</p>
//                 <ReactMarkdown className="text-gray-600" remarkPlugins={[remarkGfm]}>
//                   {detailsPart}
//                 </ReactMarkdown>
//               </div>
//             )}
//           </div>
//         ) : (
//           <p className="text-gray-500 text-center">{t("no_ref_available")}</p>
//         )}

//         <div className="flex justify-center mt-6 gap-4">
//           <button
//             onClick={() => navigate("/feedback")}
//             className="px-4 py-2 bg-[#B03982] text-white rounded-lg"
//           >
//             {t("share_feedback")}
//           </button>
//           <button
//             onClick={handleEmailClick}
//             className={`px-4 py-2 rounded-lg text-white ${isSending ? "bg-gray-400 cursor-not-allowed" : "bg-[#B03982]"
//               }`}
//             disabled={isSending}
//           >
//             {isSending ? t("sending") : t("email_this_to_me")}
//           </button>
//         </div>
//       </div>

//       {/* Image Viewer Modal */}
//       {isModalOpen && modalImageUrl && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
//           <div className="relative bg-white rounded-lg p-4 max-w-6xl max-h-[90vh] w-full mx-4 overflow-hidden shadow-lg">
//             <button
//               className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl font-bold"
//               onClick={() => {
//                 setIsModalOpen(false);
//                 setZoom(1);
//                 setTransformOrigin("center center");
//               }}
//             >
//               ✖
//             </button>

//             <div className="overflow-auto flex justify-center items-center max-h-[75vh]">
//               <img
//                 src={modalImageUrl}
//                 alt="Section"
//                 onClick={handleImageClick}
//                 style={{
//                   transform: `scale(${zoom})`,
//                   transformOrigin: transformOrigin,
//                   transition: "transform 0.25s ease-in-out",
//                   cursor: zoom === 1 ? "zoom-in" : "zoom-out",
//                 }}
//                 className="object-contain max-h-[75vh] max-w-full cursor-zoom-in"
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default References;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useTranslation } from "react-i18next";

const References = ({ isOpen, onClose, references, dir, documentInfo }) => {

  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);
  const [imageUrls, setImageUrls] = useState({});
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [transformOrigin, setTransformOrigin] = useState("center center");
  const [sectionStatus, setSectionStatus] = useState({});
  const { t } = useTranslation();

  const user = useMemo(() => {
    return JSON.parse(localStorage.getItem("profileData")) || JSON.parse(sessionStorage.getItem("profileData") || "{}");
  }, []);

  const token = useMemo(() => {
    return localStorage.getItem("token") || sessionStorage.getItem("token");
  }, []);

  // Strip any nested HTML tags out of a table cell's inner content and
  // collapse whitespace, so "<strong>Foo</strong>" -> "Foo".
  const cleanCellText = (html) =>
    html
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  // Process references into structured form.
  // The backend sends an HTML block that looks like:
  //   <h3>References:</h3>
  //   <table>
  //     <thead><tr><th>Document Name</th><th>Section Name</th><th>Section Number</th></tr></thead>
  //     <tbody><tr><td>...</td><td>...</td><td>...</td></tr>...</tbody>
  //   </table>
  // optionally followed by a "**Details:**" section.

  // const processReferences = (references) => {
  //   if (!references) return { structuredReferences: [], detailsPart: "" };

  //   // Split off an optional trailing "**Details:**" section
  //   const detailsSplit = references.split(/\*\*Details:\*\*/i);
  //   const tablePart = detailsSplit[0];
  //   const detailsPart = detailsSplit[1] ? detailsSplit[1].trim() : "";

  //   // Prefer rows inside <tbody> (skips the header row); fall back to the
  //   // whole table if there's no <tbody> wrapper.
  //   const tbodyMatch = tablePart.match(/<tbody>([\s\S]*?)<\/tbody>/i);
  //   const rowsHtml = tbodyMatch ? tbodyMatch[1] : tablePart;

  //   const structuredReferences = Array.from(
  //     rowsHtml.matchAll(/<tr>([\s\S]*?)<\/tr>/gi),
  //     (rowMatch) => {
  //       const cells = Array.from(
  //         rowMatch[1].matchAll(/<td[^>]*>([\s\S]*?)<\/td>/gi),
  //         (cellMatch) => cleanCellText(cellMatch[1])
  //       );
  //       return {
  //         documentName: cells[0] || "",
  //         sectionName: cells[1] || "",
  //         sectionNumber: cells[2] || "",
  //       };
  //     }
  //   ).filter((ref) => ref.documentName);

  //   return { structuredReferences, detailsPart };
  // };

  // const { structuredReferences, detailsPart } = useMemo(() => processReferences(references), [processReferences, references]);

  const processReferences = useCallback((references) => {
    if (!references) {
      return { structuredReferences: [], detailsPart: "" };
    }

    const detailsSplit = references.split(/\*\*Details:\*\*/i);
    const tablePart = detailsSplit[0];
    const detailsPart = detailsSplit[1] ? detailsSplit[1].trim() : "";

    const tbodyMatch = tablePart.match(/<tbody>([\s\S]*?)<\/tbody>/i);
    const rowsHtml = tbodyMatch ? tbodyMatch[1] : tablePart;

    const structuredReferences = Array.from(
      rowsHtml.matchAll(/<tr>([\s\S]*?)<\/tr>/gi),
      (rowMatch) => {
        const cells = Array.from(
          rowMatch[1].matchAll(/<td[^>]*>([\s\S]*?)<\/td>/gi),
          (cellMatch) => cleanCellText(cellMatch[1])
        );

        return {
          documentName: cells[0] || "",
          sectionName: cells[1] || "",
          sectionNumber: cells[2] || "",
        };
      }
    ).filter((ref) => ref.documentName);

    return { structuredReferences, detailsPart };
  }, []);

  const { structuredReferences, detailsPart } = useMemo(
    () => processReferences(references),
    [processReferences, references]
  );

  const checkSections = useCallback(async () => {
    const statusMap = {};

    for (const ref of structuredReferences) {
      const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;

      try {
        const params = new URLSearchParams();
        params.append("document_name", ref.documentName);
        params.append("section_name", ref.sectionName);
        params.append("section_number", ref.sectionNumber);
        params.append("tenantId", user?.tenantId || "");
        params.append("groupId", user?.groups?.[0]?.id || "");

        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/get-section-image`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
            body: params.toString(),
          }
        );

        statusMap[key] = response.ok ? "ok" : "error";
      } catch {
        statusMap[key] = "error";
      }
    }

    setSectionStatus(statusMap);
  }, [structuredReferences, user?.tenantId, user?.groups, token]);

  useEffect(() => {
    if (structuredReferences.length > 0) {
      checkSections();
    }
  }, [structuredReferences, checkSections]);

  // Handle clicking a section to fetch or show cached image
  const handleSectionClick = async (ref) => {
    const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;

    if (imageUrls[key]) {
      setModalImageUrl(imageUrls[key]);
      setZoom(1);
      setTransformOrigin("center center");
      setIsModalOpen(true);
      return;
    }

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const params = new URLSearchParams();
      params.append("document_name", ref.documentName);
      params.append("section_name", ref.sectionName);
      params.append("section_number", ref.sectionNumber);
      params.append("tenantId", user?.tenantId || null);
      params.append("groupId", user?.groups[0]?.id || null);

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/get-section-image`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
          body: params.toString(),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch image: ${response.status} - ${errorText}`
        );
      }

      const blob = await response.blob();
      const imageObjectUrl = URL.createObjectURL(blob);

      setImageUrls((prev) => ({ ...prev, [key]: imageObjectUrl }));
      setModalImageUrl(imageObjectUrl);
      setZoom(1);
      setTransformOrigin("center center");
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching section image:", error);
      alert("Error fetching section image.");
    }
  };

  // Zoom handling
  const handleImageClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    const yPercent = ((e.clientY - rect.top) / rect.height) * 100;

    if (zoom === 1) {
      setTransformOrigin(`${xPercent}% ${yPercent}%`);
      setZoom(2.5);
    } else {
      setZoom(1);
      setTransformOrigin("center center");
    }
  };

  // Email references
  const handleEmailClick = async () => {
    if (isSending) return;
    setIsSending(true);

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const email = localStorage.getItem("user");
      if (!email) {
        alert("User email not found in local storage!");
        setIsSending(false);
        return;
      }

      const emailContent = `<html><body><h2>Your References</h2><table><thead><tr><th>Document Name</th><th>Section Name</th><th>Section Number</th></tr></thead><tbody>${structuredReferences
        .map(
          (ref) =>
            `<tr><td>${ref.documentName}</td><td>${ref.sectionName}</td><td>${ref.sectionNumber}</td></tr>`
        )
        .join("")}</tbody></table><br/><p><strong>Details:</strong><br/>${detailsPart?.replace(
          /\n/g,
          "<br/>"
        )}</p></body></html>`;

      const response = await axios.post(
        `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/client/sendRefrenceEmail`,
        { email, content: emailContent },
        { headers: { token, "Content-Type": "application/json" } }
      );

      if (response.status === 200 || response.status === 201) {
        navigate("/references-email");
      } else {
        console.error("Failed to send email:", response.statusText);
        setIsSending(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setIsSending(false);
    }
  };

  // Determine document clickability
  // const isViewableGroup = user?.groups?.some((g) => g.isViewable === true);
  // const isDocumentClickable = (isViewableGroup === true || user?.isDocViewable === true) || (isViewableGroup === true && user?.isDocViewable === true);
  // const isDocumentClickable = (isViewableGroup === true || user?.isDocViewable === true) || (isViewableGroup === true && user?.isDocViewable === true);
  const mapData = structuredReferences?.map((reference) => {
    const matchDoc = documentInfo?.find((doc) => reference.documentName.replace(/\.pdf$/i, '') === doc.documentName.replace(/\.pdf$/i, ''))
    console.log({ matchDoc, documentInfo, reference });
    return {
      ...reference,
      data: matchDoc?.data?.data
    }
  })

  console.log('map data ===>', {
    references
  });

  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-5xl px-6 pb-6 rounded-lg">
        <h1 className="text-xl font-bold mb-8 text-center">{t("references")}</h1>
        {structuredReferences.length > 0 ? (
          <div className="overflow-y-auto max-h-[60vh]">
            <table className="table-auto w-full border-collapse border border-gray-300">
              <thead>
                <tr className={`bg-gray-200 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>
                  <th className="border border-gray-300 px-4 py-2 ">
                    {t("document_name")}
                  </th>
                  <th className="border border-gray-300 px-4 py-2 ">
                    {t("section_name")}
                  </th>
                  <th className="border border-gray-300 px-4 py-2 ">
                    {t("section_number")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {mapData?.map((ref, index) => {
                  const key = `${ref.documentName}|${ref.sectionName}|${ref.sectionNumber}`;
                  // Extract the complex viewability logic to a function
                  const isViewable = () => {
                    const hasNoGroup = ref.data?.group === null;
                    const isConfidential = ref.data?.group?.type === "CONFIDENTIAL";
                    const isGroupViewable = user?.groups[0]?.isViewable === true;
                    const isDocViewable = user?.isDocViewable;
                    // Case 1: No group, doc is viewable
                    if (hasNoGroup && isDocViewable === true) return true;
                    // Case 2: No group, group not viewable, but doc is viewable
                    if (hasNoGroup && user?.groups[0]?.isViewable === false && isDocViewable === true) return true;
                    // Case 3: Confidential group or no group, group is viewable, doc not viewable
                    if ((isConfidential || hasNoGroup) && isGroupViewable && isDocViewable === false) return true;
                    // Case 4: Confidential group or no group, both group and doc are viewable
                    if ((isConfidential || hasNoGroup) && isGroupViewable && isDocViewable === true) return true;
                    return false;
                  };
                  return (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-4 py-2">
                        {isViewable() ? (
                          <span
                            onClick={() =>
                              window.open(
                                `https://nb-client1.s3.ap-southeast-1.amazonaws.com/${ref.documentName}`,
                                "_blank"
                              )
                            }
                            className="text-blue-500 cursor-pointer"
                          >
                            {ref.documentName}
                          </span>
                        ) : (
                          ref.documentName
                        )}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {ref.sectionName}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {sectionStatus[key] === "ok" && ref.sectionNumber !== "N/A" ? (
                          <span
                            className="text-blue-600 cursor-pointer underline"
                            onClick={() => handleSectionClick(ref)}
                          >
                            {ref.sectionNumber}
                          </span>
                        ) : (
                          <span className="text-gray-500">{ref.sectionNumber}</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {detailsPart && (
              <div className="mt-4">
                <p className="font-bold">{t("details")}</p>
                <ReactMarkdown className="text-gray-600" remarkPlugins={[remarkGfm]}>
                  {detailsPart}
                </ReactMarkdown>
              </div>
            )}
          </div>
        ) : (
          <p className="text-gray-500 text-center">{t("no_ref_available")}</p>
        )}

        <div className="flex justify-center mt-6 gap-4">
          <button
            onClick={() => navigate("/feedback")}
            className="px-4 py-2 bg-[#B03982] text-white rounded-lg"
          >
            {t("share_feedback")}
          </button>
          <button
            onClick={handleEmailClick}
            className={`px-4 py-2 rounded-lg text-white ${isSending ? "bg-gray-400 cursor-not-allowed" : "bg-[#B03982]"
              }`}
            disabled={isSending}
          >
            {isSending ? t("sending") : t("email_this_to_me")}
          </button>
        </div>
      </div>

      {/* Image Viewer Modal */}
      {isModalOpen && modalImageUrl && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="relative bg-white rounded-lg p-4 max-w-6xl max-h-[90vh] w-full mx-4 overflow-hidden shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl font-bold"
              onClick={() => {
                setIsModalOpen(false);
                setZoom(1);
                setTransformOrigin("center center");
              }}
            >
              ✖
            </button>

            <div className="overflow-auto flex justify-center items-center max-h-[75vh]">
              <img
                src={modalImageUrl}
                alt="Section"
                onClick={handleImageClick}
                style={{
                  transform: `scale(${zoom})`,
                  transformOrigin: transformOrigin,
                  transition: "transform 0.25s ease-in-out",
                  cursor: zoom === 1 ? "zoom-in" : "zoom-out",
                }}
                className="object-contain max-h-[75vh] max-w-full cursor-zoom-in"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default References;